// user action types
export const SET_USER = "SET USER";
export const CLEAR_USER = "CLEAR USER";

//channel action types
export const SET_CURRENT_CHANNEL = "SET CURRENT CHANNEL";
export const SET_PRIVATE_CHANNEL = "SET PRIVATE CHANNEL";
export const SET_USER_POSTS = "SET USER POSTS";

//colors action types
export const SET_COLORS = "SET COLORS";



// WEBPACK FOOTER //
// ./src/actions/types.js